import { IPD_COLORS } from '../inventory/theme';

export const OT_SECTION_HEADER_GRADIENT = 'linear-gradient(135deg, #ffffff 0%, #f0f7fb 55%, #e8f4fc 100%)';
export const OT_SELECTED_GRADIENT = 'linear-gradient(135deg, #f0f9ff 0%, #e1f5fe 100%)';

export const OT_PAGE_SX = {
  minHeight: '100%',
  background: 'linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%)',
  p: { xs: 2, sm: 2.5, md: 3 },
};

export const OT_SECTION_SX = {
  boxShadow: '0 2px 14px rgba(26, 43, 75, 0.07)',
  border: `1px solid ${IPD_COLORS.border}`,
  '& > div:first-of-type': {
    background: OT_SECTION_HEADER_GRADIENT,
  },
};

export const OT_SUBMIT_BAR_SX = {
  display: 'flex',
  justifyContent: 'flex-end',
  p: 2,
  borderRadius: 2,
  background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
  border: `1px solid ${IPD_COLORS.border}`,
  boxShadow: '0 2px 12px rgba(26, 43, 75, 0.06)',
};

// No `background` here on purpose. This used to paint the button with a
// teal->navy gradient while leaving the button's inherited white label alone,
// which put #FFFFFF on #64E0D9 at the light end — 1.59:1, illegible. Let the
// button keep its own contrast-checked background; only the width is ours.
export const OT_SUBMIT_BTN_SX = {
  minWidth: 140,
};
